import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ResultContent } from '@/shared/components';
import { useModalStore } from '@/shared/lib';
import UnsuccessDocumentsIcon from '@/shared/assets/unsuccess-documents-icon.svg?react';

export function BankTransferErrorContent() {
  const { t } = useTranslation();
  const { closeDialog, setMultipleState } = useModalStore();

  useEffect(() => {
    setMultipleState({ isLoading: false });
  }, [setMultipleState]);

  return (
    <ResultContent
      title={t('common.errorTitle')}
      description={t('depositMethods.bankTransfer.listsError')}
      isSuccess={false}
      icon={<UnsuccessDocumentsIcon className="size-[6.4rem]" />}
      titleClassName="headline4"
      descriptionClassName="p4"
      className="h-auto"
      buttonText={t('common.close')}
      buttonVariant="secondary"
      onClick={closeDialog}
    />
  );
}
